import angular from "angular";
// import "angular-resource";
import { RestService } from "./rest.service";

export class RestProvider implements angular.IServiceProvider {

    private SERVICE_CONFIGS: { [name: string]: qpmn.common.rest.IHttpRestConfig } = {};

    private RETRY_MAX_TIME: number = 5;

    private RETRY_TIME_SPAN: number = 3000;

    private DEFAULT_HEADER?: angular.IHttpRequestConfigHeaders = {
        "Content-Type": "application/json"
    }

    /**
     * 重试最大次数
     * @param times 
     */
    public setRetryMaxTime(times: number) {
        this.RETRY_MAX_TIME = times;
    }

    /**
     * 两次重试之间的间隔
     * @param timeSpan 
     */
    public setRetryTimeSpan(timeSpan: number) {
        this.RETRY_TIME_SPAN = timeSpan;
    }

    /**
     * @description 设置默认Header
     * @param serviceName 
     * @param functionName 
     * @param config 
     */
    public setDefaultHeaders(headers?: angular.IHttpRequestConfigHeaders) {
        this.DEFAULT_HEADER = headers;
    }

    /**
     * 配置单个Rest请求
     * @param serviceName 
     * @param functionName 
     * @param config 
     */
    public config(serviceName: string, functionName: string, config: qpmn.common.rest.IHttpRestConfig) {
        if (config) {
            this.SERVICE_CONFIGS[serviceName + "__" + functionName] = config;
        }
    }

    /**
    * 配置多个Rest请求
    * @param configs { config }
    */
    public configs(configs: Array<qpmn.common.rest.IServiceConfig>) {
        if (configs && configs.length > 0) {
            for (let index = 0; index < configs.length; index++) {
                const cfgObj = configs[index];

                if (cfgObj && cfgObj.config) {
                    this.SERVICE_CONFIGS[cfgObj.service + "__" + cfgObj.funcName] = cfgObj.config;
                }
            }
        }
    }

    /**
     * service的工厂
     */
    public $get = ["$http", "$q", "$timeout", "urlBuilder", "restRuntime",
        function RestServiceFactory($http: angular.IHttpService, $q: angular.IQService, $timeout: angular.ITimeoutService, urlBuilder, restRuntime: qpmn.common.rest.IRestRuntime) {

            let restConfig: qpmn.common.rest.IRestServiceConfig = {
                serviceConfigs: this.SERVICE_CONFIGS,
                retryMaxTime: this.RETRY_MAX_TIME,
                retryTimeSpan: this.RETRY_TIME_SPAN,
                defaultHeaders: this.DEFAULT_HEADER
            }

            return new RestService($http, $q, $timeout, urlBuilder, restRuntime, restConfig);
        }
    ];

}